export default __webpack_public_path__ + "static/media/image1.90becb3d.svg";